import { React, useState, useEffect } from "react";

const PopUpDusDumResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let dusKaDumCard = "";
    let dusKaDumMarkets = [];
    let dusKaDumWinner = "";

    if (marketType == 46) {

        dusKaDumCard = resultData.ac1 || "";

        dusKaDumMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
            resultData.cat_rnr3,
            resultData.cat_rnr4,
            resultData.cat_rnr5,
            resultData.cat_rnr6,
            resultData.cat_rnr7,
            resultData.cat_rnr8,
            resultData.cat_rnr9,
            resultData.cat_rnr10,
        ].filter(Boolean);

        dusKaDumWinner = resultData.resultTxt || "";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="dus-ka-dum" style={{ display: marketType == 46 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span
                                                className="name"
                                                style={{ color: "#000" }}
                                            >
                                                Winning Card
                                            </span>
                                        </b>
                                        <div className="player-card" style={{ display: "flex", justifyContent: "center" }}>
                                            <div className="BFBCardHandViewDealerab" style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                                <div className="BFBCardFanViewab" style={{ display: "flex", justifyContent: "center", padding: "3px" }}>
                                                    {dusKaDumCard && (
                                                        <div className="RSMImageView2ab">
                                                            <img src={`/assets/images/cards/${dusKaDumCard}.svg`} style={{ width: "100%", maxWidth: "55px", height: "auto" }} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {dusKaDumMarkets.map((market, index) => {
                                            const winner = market === dusKaDumWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
};

export default PopUpDusDumResults;

